module.exports = __webpack_public_path__ + "static/1293735269-wide.2708c934.jpg";